var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExtendedApolloQuery',{attrs:{"query":_vm.query,"variables":_vm.queryVariables},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('div',{staticClass:"d-flex justify-content-center"},[(data.suggestionsListForProject != null)?_c('router-link',{attrs:{"to":{name: 'suggestionsList', params:
					 {suggestionsListId:
					 data.suggestionsListForProject.id},
					 query: {
					 projectId: _vm.projectId
					 }
					 }}},[_vm._v(" Voir la liste de suggestions ")]):_vm._e(),_c('div')],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }